module.exports = __webpack_public_path__ + "img/mobile-menu.079fb72f.png";